import { useDispatch } from 'react-redux'
import { BASE_MEDIA_QUERY } from '../../static/config'
import { uiActions } from '../../store/ui'

const CheckResize = () => {
  const dispatch = useDispatch()

  window.addEventListener('resize', () => {
    let sidenavValue
    if (!BASE_MEDIA_QUERY.matches) {
      sidenavValue = false
    } else {
      sidenavValue = true
    }
    dispatch(uiActions.toggleSidenav(sidenavValue))
  })

  return null
}

export default CheckResize
